<ng-template #dialogContent>
    <div *ngIf="uploadedFiles.length">
        <button-spacer *ngIf="data.newStyles" [size]="'sm'"></button-spacer>
        <div class="gallery">
        <span
            *ngFor="let a of uploadedFiles"
            [addClassOnHover]="'hovering'"
            class="item p-relative"
            id="attachment-{{ a.id }}"
        >
            <img class="icon-image mx-auto" src="/assets/images/app/icons/file_icons/{{ a.icon }}.svg"/>

            <!-- deletion icon, visible only on hover -->
            <!-- todo add permissions around the delete button -->
            <img
                *ngIf="!data.hideUploader"
                (click)="deleteUploadedFile(a)"
                class="edit-image delete"
                src="/assets/images/payhoa/other/delete-image-icon.svg"
            />

            <!-- visible not on hover -->
            <span class="item-footer">
                <span>{{ a.fileName.length > 15 ? (a.fileName | slice: 0:15) + '...' : a.fileName }}</span>
            </span>

            <!-- visible on hover -->
            <a class="item-title-hover" href="{{ a.viewUrl }}" target="_blank">
                <span class="title">{{ a.fileName }}</span
                ><br/>
                <span class="size">{{ a.fileSize | legfiFilesize }}</span>
            </a>
        </span>
        </div>
    </div>

    <!-- this section shows only if there are existing attachments -->
    <div *ngIf="data.type === 'transaction' && data.transaction.attachments.length">
        <div *ngIf="data.transaction.attachments.length" class="gallery">
        <span *ngFor="let a of data.transaction.attachments" [addClassOnHover]="'hovering'" class="item p-relative">
            <i class="fa fa-file text-secondary fa-2x mx-auto mt-4"></i>

            <!-- deletion icon, visible only on hover -->
            <!-- todo add permissions around the delete button -->
            <img *ngIf="!data.hideUploader"
                (click)="deleteAttachment(a)"
                class="edit-image delete"
                src="/assets/images/payhoa/other/delete-image-icon.svg"
            />

            <!-- visible not on hover -->
            <span class="item-footer">
                <i class="{{ a.icon }}"></i>
                <span>{{ a.filename.length > 15 ? (a.filename | slice: 0:15) + '...' : a.filename }}</span>
            </span>

            <!-- visible on hover -->
            <a (click)="openAttachment(a.url)" class="item-title-hover">
                <i class="{{ a.icon }}"></i> <span class="title">{{ a.filename }}</span
            ><br/>
                <span class="size">{{ a.filesize }}</span>
            </a>
        </span>
        </div>
    </div>

    <div *ngIf="!data.hideUploader">
        <div class="drag-and-drop"
             [class.dropping]="isOverDropZone"
             [uploader]="fileUploader"
             (fileOver)="fileOverDropzone($event)"
             ng2FileDrop>
            <ng-template #legacyUploadLabel>
                <img src="/assets/images/app/icons/cloud-upload-icon.png"/>
                <p>Drag and drop files here, or <br/>
                    <label (click)="fileUploader.clearQueue()" class="custom-upload-label">
                        <input class="custom-file-input"
                               name="attachment[]"
                               type="file"
                               [uploader]="fileUploader"
                               multiple
                               ng2FileSelect
                        />
                        select files
                    </label>
                </p>
            </ng-template>
            <ng-container *ngIf="data.newStyles; else legacyUploadLabel">
                <div class="upload-label">
                    <mat-icon>cloud_upload</mat-icon>
                    <p>{{ 'Drag and drop files here, or' }}</p>
                    <button mat-flat-button disableRipple color="primary">
                        <label (click)="fileUploader.clearQueue()">
                            <input class="custom-file-input"
                                   name="attachment[]"
                                   type="file"
                                   [uploader]="fileUploader"
                                   multiple
                                   ng2FileSelect
                            />
                            {{ 'Select Files' }}
                        </label>
                    </button>
                </div>
            </ng-container>
        </div>

        <div *ngIf="fileUploader.queue.length > 0" class="file-contents">
            <div *ngFor="let item of fileUploader.queue" class="file">
                <span class="name">{{ item?.file?.name }}</span>
                <span class="item-size ml-2">{{ item?.file?.size }}</span>
                <span (click)="item.remove()" class="mt-1 float-right text-danger">
                <i class="fa fa-trash"></i>
            </span>
            </div>
        </div>

        <div class="count-uploaded-files">
            {{ fileUploader.queue.length }} file<span *ngIf="fileUploader.queue.length !== 1">s</span>
            added
        </div>

        <p class="instrux">
            Maximum upload file size 100 MB.
        </p>


        <div *ngIf="fileUploader.isUploading" class="mt-3">
            <mat-progress-bar
                [value]="fileUploader.progress"
                color="primary"
                mode="determinate">
            </mat-progress-bar>
        </div>
    </div>
</ng-template>

<ng-template #legacyDialog>
    <h3 mat-dialog-title>{{ title }}</h3>

    <mat-dialog-content>
        <ng-container *ngTemplateOutlet="dialogContent"></ng-container>
    </mat-dialog-content>

    <mat-dialog-actions *ngIf="!data.hideUploader">
        <button mat-dialog-close class="btn btn-outline-secondary">
            Cancel
        </button>

        <button
            (click)="processFiles()"
            [disabled]="isAttaching || !fileUploader.queue.length"
            class="btn btn-primary"
        >
            Upload {{ fileUploader.queue.length }} file(s)
        </button>
    </mat-dialog-actions>

    <mat-dialog-actions class="one-button" >
        <button mat-dialog-close class="btn btn-outline-secondary">
            Ok
        </button>
    </mat-dialog-actions>
</ng-template>

<ng-container *ngIf="data.newStyles; else legacyDialog">
    <h3 mat-dialog-title>
        {{ 'Attachments' }}
        <button mat-icon-button disableRipple mat-dialog-close><mat-icon>close</mat-icon></button>
    </h3>

    <mat-dialog-content>
        <ng-container *ngTemplateOutlet="dialogContent"></ng-container>
    </mat-dialog-content>

    <mat-dialog-actions>
        <button mat-flat-button disableRipple color="accent" mat-dialog-close>
            {{ data.hideUploader ? 'Close' : 'Cancel' }}
        </button>
        <button-spacer></button-spacer>
        <button *ngIf="!data.hideUploader"
                mat-flat-button disableRipple color="primary"
                [disabled]="isAttaching || !fileUploader.queue.length"
                (click)="processFiles()">
            {{ fileUploader.queue.length | i18nPlural: filesMapping }}
        </button>
    </mat-dialog-actions>
</ng-container>


